import type { FC, PropsWithChildren } from 'react';
import TextBoxStyles from '../InputBox/TextBox.module.css';

type TextAreaProps = PropsWithChildren<{
  icon?:string;
  icon2?:string
  className?:string
  placeholder?: string;
  rows?: number;
  value: string;
  errorMessage?: string;
  label?: string;
  disabled?: boolean;
  defaultValue?: string;
  style?: React.CSSProperties;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onClickIcon1?: React.MouseEventHandler<SVGSVGElement>;
  onClickIcon2?: React.MouseEventHandler<SVGSVGElement>;
  
}>;

const TextArea: FC<TextAreaProps> = ({ icon2,icon,className, placeholder, rows = 4, value, onChange, errorMessage, label, style, disabled, defaultValue,onClickIcon1,onClickIcon2}) => {
  return (
    <div className={TextBoxStyles.form_input}>
      {label && (
        <label htmlFor={label} className={TextBoxStyles.form_input__label}>
          {label}
        </label>
      )}
      <div className={TextBoxStyles.form_input__container} style={style}>
      {/* {icon && (
          <svg className={TextBoxStyles.form_input__icon} onClick={onClickIcon1} >
            <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
          </svg>
        )} */}
          {icon2 && (
          <svg className={TextBoxStyles.form_input__icon} onClick={onClickIcon2}  >
            <use xlinkHref={`/assets/sprite.svg#${icon2}`} />
          </svg>
        )}
        <textarea
          id={label}
          disabled={disabled ? disabled : false}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          // className={TextBoxStyles.form_input__box}
          className={`${TextBoxStyles.form_input__box} ${className || ''}`}
          rows={rows}
        />
      </div>
      {errorMessage && <p className={TextBoxStyles.form_input__error}>{errorMessage}</p>}
    </div>
  );
};

export default TextArea;
